$(document).ready(function() {
  // Toggle the offer list for the specific offer container when the button is clicked
  $(".offer-button1, .offer-button2, .offer-button3, .offer-button4").click(function() {
    $(this).siblings(".offer-list").slideToggle("slow");
  });

  // Toggle the visibility of the full list of offers when the "View All" button is clicked
  $(".available_offer_view_button").click(function(e) {
    e.preventDefault(); // Prevent the default behavior of the <a> tag
    $(".toggle-rest-offer-wrapper").slideToggle("slow");
  });

});

$(document).on("click", ".modal.modal--quick-shop .offer-button1, .modal.modal--quick-shop .offer-button2, .modal.modal--quick-shop .offer-button3, .modal.modal--quick-shop .offer-button4", function() {
  // Find the closest modal and then toggle the sibling .offer-list of the clicked button
  $(this).siblings(".offer-list").slideToggle("slow");
});

$(document).on("click", ".modal.modal--quick-shop .available_offer_view_button", function(e) {
  e.preventDefault(); // Prevent default <a> behavior
  // Find the closest modal and toggle only its specific .toggle-rest-offer-wrapper
  $(this).closest(".modal").find(".toggle-rest-offer-wrapper").slideToggle("slow");
});
//add to cart
jQuery(document).ready(function($) {
  // Delegated event for custom_variant
  $(document).on('click', '.custom_variant', function(e) {
    e.preventDefault();
    if (!$(this).hasClass('crossed')) {
      $(this).closest('.customt-quick-variant-wrapper').find('.custom_variant').removeClass('selected');
      $(this).addClass('selected');
      var current_var_id = $(this).attr('data-variant-id');
      $(this).closest('.custom_variant_box').find('.custom_atc').attr('data-variant-id', current_var_id);
    }
  });

  // Delegated event for custom_atc
  $(document).on('click', '.custom_atc', function(e) {
    e.preventDefault();
    var this_btn = $(this);
    var var_id = $(this).attr('data-variant-id');
    $(this).addClass('btn--loading');

    var addData = {
      'id': var_id,
      'quantity': 1
    };

    fetch('/cart/add.js', {
      body: JSON.stringify(addData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      method: 'POST'
    }).then(function(response) {
      return response.json();
    }).then(function(data) {
      if (data.status === 422) {
        alert('Something wrong! Please reload page.');
        location.reload();
      } else {
        var product = data;
        setTimeout(function() {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: product,
              addToCartBtn: this_btn
            }
          }));
          this_btn.removeClass('btn--loading');
        }, 1200);
      }
    }).catch(function(err) {
      alert('Something wrong! Please reload page.');
      location.reload();
    });
  });
});


